import { relations } from "drizzle-orm";
import { pgTable, text, uuid } from "drizzle-orm/pg-core";
import { group } from "../group/group.sql";
import { scope } from "../scope/scope.sql";
import { temporalTimestamps } from "../../utils/sql";

export const space = pgTable("space", {
  id: uuid("id")
    .primaryKey()
    .references(() => group.id),
  ...temporalTimestamps,
  name: text("name").notNull(),
});

export const spaceRelations = relations(space, ({ one }) => ({
  group: one(group, {
    fields: [space.id],
    references: [group.id],
  }),
  scope: one(scope, {
    fields: [space.id],
    references: [scope.id],
  }),
}));
